import { Table } from '@app/modules/table/classes/table.class';
import { AuthService } from '@app/services';
import { Paginator } from '@app/classes';
import { BenefitPlan } from '@models/benefits/benefit-plan.model';
import { BenefitChangeRequest } from '@models/benefits/benefit-change-request.model';
import { Injectable } from '@angular/core';
import { NameColumn, StatusColumn, SubmissionDateColumn } from '@benefits/services/tables/change-request-table/columns';

@Injectable()
export class ChangeRequestIndexTable extends Table {
    links = true;

    constructor(
        protected auth: AuthService,
        private benefitPlan: BenefitPlan
    ) {
        super(auth);

        this.boot();
    }

    getLink(changeRequest: BenefitChangeRequest): (string | number)[] {
        return ['/benefits', 'plans', this.benefitPlan.id, 'change-requests', changeRequest.id];
    }

    setColumns(): void {
        this.addColumns(new NameColumn(), new SubmissionDateColumn(), new StatusColumn());
    }

    setDataSource(): void {
        this.paginator = new Paginator(
            BenefitChangeRequest.param('company', this.auth.company.id)
                .param('benefitPlan', this.benefitPlan.id)
                .whereIn('status', ['pending', 'declined', 'accepted'])
                .with(['employee'])
        );
    }
}
